import queryString from 'query-string';
import { OrderProperty } from 'src/adminPanel/components/offsetting/orders/details/OrderPropertyDetails';
import AdditionalProductRequestParams from 'src/adminPanel/components/offsetting/orders/dialog/AdditionalProductRequestParams';
import { ExportOrderCSVRequest } from 'src/adminPanel/entities/offsetting/order/ExportOrderCSVRequest';
import Order from 'src/adminPanel/entities/offsetting/order/Order';
import { OrderFilter } from 'src/adminPanel/entities/offsetting/order/OrderFilter';
import { OrderRequestFilter } from 'src/adminPanel/entities/offsetting/order/OrderRequestFilter';
import { Address } from 'src/entities/basic-types/Address';
import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import SelectedProduct from 'src/entities/cart/request/SelectedProduct';
import CustomFieldOrderProduct from 'src/entities/cart/response/CustomFieldOrderProduct';
import callApi, { CallApiResult, Params } from '.';

export const getOrdersByFilter = (
    pageable: PageableQueryParams = {},
    filter: OrderRequestFilter = new OrderRequestFilter('')
) => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/orders/overview${query}`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

export const getOrdersByFilterId = (filterId: string, pageable: PageableQueryParams = {}) => {
    let query = queryString.stringify({ ...pageable }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;
    const endpoint = `/api/orders/overview/${filterId}${query}`;
    return callApi(endpoint);
};

export const getOrderFilter = () => {
    const endpoint = '/api/orders/filter';
    return callApi(endpoint);
};

export const createNewOrderFilter = (filter: OrderFilter) => {
    const endpoint = `/api/orders/filter`;
    return callApi(endpoint, { method: 'POST', data: filter });
};

export const deleteOrderFilter = (filterId: string) => {
    const endpoint = `/api/orders/filter/${filterId}`;
    return callApi(endpoint, { method: 'DELETE' });
};

export const saveOrderFilter = (filter: OrderFilter) => {
    const endpoint = `/api/orders/filter`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

export const fetchOrderProductDetailsCall = (publicId: string) => {
    const endpoint = '/ordering/' + publicId;
    return callApi(endpoint);
};
export const saveOrderProductDetails = (filter: OrderFilter) => {
    const endpoint = `/api/orders/filter`;
    return callApi(endpoint, { method: 'PUT', data: filter });
};

export const saveOrder = (publicId: string, order: Order, additionalParams?: AdditionalProductRequestParams) => {
    const endpoint = '/ordering/' + publicId;
    const params: Params | undefined = additionalParams
        ? {
              updateCoffeeTax: additionalParams.updateCoffeeTax ? 1 : 0,
              updateDeliveryCosts: additionalParams.updateDeliveryCosts ? 1 : 0,
              updatePremiumLevel: additionalParams.updatePremiumLevel ? 1 : 0,
              updateRebates: additionalParams.updateRebates ? 1 : 0,
              updateCommissionModels: additionalParams.updateCommissionModels ? 1 : 0,
          }
        : undefined;
    return callApi(endpoint, { method: 'PUT', data: order, params });
};

export const saveBillingAddressOrder = (publicId: string, address: Address) => {
    const endpoint = `/ordering/${publicId}/billingAddress`;
    return callApi(endpoint, { method: 'PUT', data: address });
};

export const saveDeliveryAddressOrder = (publicId: string, address: Address) => {
    const endpoint = `/ordering/${publicId}/deliveryAddress`;
    return callApi(endpoint, { method: 'PUT', data: address });
};

export const saveOrderProductCustomField = (orderProductCustomfield: CustomFieldOrderProduct) => {
    const endpoint = `/ordering/orderProduct/customField/save`;
    return callApi(endpoint, { method: 'POST', data: orderProductCustomfield });
};

export const updateOrderProductCustomField = (orderProductCustomfield: CustomFieldOrderProduct) => {
    const endpoint = `/ordering/orderProduct/customField/update`;
    return callApi(endpoint, { method: 'PUT', data: orderProductCustomfield });
};

export const deleteOrderProductCustomField = (orderProductCustomfieldId: number) => {
    const endpoint = `/ordering/orderProduct/customField/delete/${orderProductCustomfieldId}`;
    return callApi(endpoint, { method: 'DELETE' });
};

export const saveOrderProperty = (orderProperty: OrderProperty) => {
    const endpoint = `/api/admin/orderProperty`;
    return callApi(endpoint, { method: 'PUT', data: orderProperty });
};

export const deleteOrderProperty = (orderId: number, propertyKey: string) => {
    const endpoint = `/api/admin/orderProperty/${orderId}/${propertyKey}`;
    return callApi(endpoint, { method: 'DELETE' });
};

export const createOrderProduct = (publicId: string, orderProduct: SelectedProduct): Promise<CallApiResult> => {
    const endpoint = `/ordering/${publicId}/createOrderProduct`;
    return callApi(endpoint, { method: 'POST', data: orderProduct });
};

export const exportOrdersCSV = (exportOrderCSVRequest: ExportOrderCSVRequest): Promise<CallApiResult> => {
    return callApi('/api/orders/csvExport', { responseType: 'blob', method: 'PUT', data: exportOrderCSVRequest });
};
